import { MemberRolesModel } from '../models/member-roles.model';
import RequestCreator from './helpers/requestCreator';

class MemberRoles extends RequestCreator<MemberRolesModel> {}

const api = new MemberRoles('/member-roles');
export default api;
